/**
 * Utility functions for installment payments
 */

/**
 * Formats an installment number with the correct ordinal suffix
 * @param {number} installmentNumber - The installment number
 * @returns {string} Formatted installment number (e.g., "1st", "2nd", "3rd", "4th")
 */
export const formatInstallmentNumber = (installmentNumber) => {
  if (!installmentNumber) return '';
  
  const num = parseInt(installmentNumber);
  const suffix = num === 1 ? 'st' : num === 2 ? 'nd' : num === 3 ? 'rd' : 'th';
  return `${num}${suffix}`;
};

/**
 * Gets the formatted payment type with installment number
 * @param {string} transactionType - The transaction type ('emi_payment' or 'split_payment')
 * @param {number} installmentNumber - The installment number
 * @returns {string} Formatted payment type (e.g., "1st Installment", "2nd Installment", "EMI Payment")
 */
export const getPaymentTypeWithInstallment = (transactionType, installmentNumber) => {
  const baseType = transactionType === 'emi_payment' ? 'EMI Payment' : 'Split Payment';
  
  if (installmentNumber) {
    const formattedNumber = formatInstallmentNumber(installmentNumber);
    return `${formattedNumber} Installment`;
  }
  
  return baseType;
};
